var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import camelcaseKeys from 'camelcase-keys';
var transformSummaryResponse = function (response) {
    var _a;
    var data = camelcaseKeys(response, { deep: true });
    var summaryItems = (_a = data === null || data === void 0 ? void 0 : data.summaries[0]) === null || _a === void 0 ? void 0 : _a.summaries;
    var transformedData = summaryItems === null || summaryItems === void 0 ? void 0 : summaryItems.map(function (summary) { return (__assign(__assign({}, summary), { key: summary.key.replace(/^(Lease|Cash|Finance)/, '') })); });
    return { transformedData: transformedData, originalResponse: response };
};
export default transformSummaryResponse;
